// Registry of the wizard's per-template catalogs, mirroring the backend's
// services/cer/templates.js by `id`.
//
// A catalog owns everything that varies between one kind of AI-generated report
// and another — which sections exist, which fields they need, which config
// tables the payload may carry — so nothing in the wizard components hardcodes a
// section key or a field name.
import cer from "./cer";
import { p8StabilitySummary, p8StabilityProtocol, p8StabilityData } from "./stability";
import composition from "./composition";
import p4Specifications from "./p4-specifications";

const TEMPLATES = {
    [cer.id]: cer,
    [p8StabilitySummary.id]: p8StabilitySummary,
    [p8StabilityProtocol.id]: p8StabilityProtocol,
    [p8StabilityData.id]: p8StabilityData,
    [composition.id]: composition,
    [p4Specifications.id]: p4Specifications,
};

const DEFAULT_TEMPLATE = cer.id;

/**
 * The catalog for a template id. Falls back to the default rather than throwing,
 * the same way the backend's `getTemplate` does: a document created before
 * `aiTemplate` existed carries a null id and is a CER.
 */
export function resolveTemplate(id) {
    return TEMPLATES[id || DEFAULT_TEMPLATE] || TEMPLATES[DEFAULT_TEMPLATE];
}

export default TEMPLATES;
